import React, { useEffect, useState } from "react";
import { axiosInstance } from "../utils/axiosInstance";
// import WishlistCard from "./WishlistCard";
import Loader from "../Loader";
import MenuCart from "../Menu/MenuCart";
import ShareSocialModal from "../ShareSocialModal";

const WishList = () => {
  const [loader, setloader] = useState(false);

  const [allWishlist, setAllWishlist] = useState([]);

  const [url, setUrl] = useState("");
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);

  const getAllWishlist = async () => {
    setloader(true);
    try {
      await axiosInstance.get("user/whishlist").then((response) => {
        if (response?.data?.status === true) {
          setloader(false);

          setAllWishlist(response?.data?.whishlists);
        }
      });
    } catch (error) {
      setloader(true);
    }
  };

  useEffect(() => {
    getAllWishlist();
  }, []);

  return (
    <div className="dashboard_content">
      <div className="dashboard_body">
        <h3>Favourite</h3>
        {loader ? (
          <Loader />
        ) : (
          <div className="dashoard_wishlist">
            {allWishlist ? (
              <div className="row">
                {allWishlist?.map((e, i) => (
                  <MenuCart
                    setShowModal={setShowModal}
                    setUrl={setUrl}
                    heart={true}
                    wishlistCol={true}
                    getAllWishlist={getAllWishlist}
                    productData={e?.product}
                  />
                ))}
              </div>
            ) : (
              <>No Favourite Data Found..!</>
            )}
          </div>
        )}
      </div>
      <ShareSocialModal
        showModal={showModal}
        handleClose={handleClose}
        url={url}
      />
    </div>
  );
};

export default WishList;
